import { FootballGame } from '@/types';

const TEAM_ALIASES: Record<string, string> = {
  brasil: 'brazil',
  brazil: 'brazil',
  japao: 'japan',
  japan: 'japan',
  suica: 'switzerland',
  switzerland: 'switzerland',
  tunisia: 'tunisia',
  espanha: 'spain',
  spain: 'spain',
  arabiasaudita: 'saudiarabia',
  saudiarabia: 'saudiarabia',
  belgica: 'belgium',
  belgium: 'belgium',
  ira: 'iran',
  iran: 'iran',
  uruguai: 'uruguay',
  uruguay: 'uruguay',
  caboverde: 'capeverde',
  capeverde: 'capeverde',
  novazelandia: 'newzealand',
  newzealand: 'newzealand',
  egito: 'egypt',
  egypt: 'egypt',
  argentina: 'argentina',
  alemanha: 'germany',
  germany: 'germany',
  franca: 'france',
  france: 'france',
  inglaterra: 'england',
  england: 'england',
  italia: 'italy',
  italy: 'italy',
  portugal: 'portugal',
  holanda: 'netherlands',
  paisesbaixos: 'netherlands',
  netherlands: 'netherlands',
  estadosunidos: 'usa',
  unitedstates: 'usa',
  usa: 'usa',
  mexico: 'mexico',
  marrocos: 'morocco',
  morocco: 'morocco',
  canad: 'canada',
  canada: 'canada',
  australia: 'australia',
  coreiadosul: 'southkorea',
  korearepublic: 'southkorea',
  southkorea: 'southkorea',
  costarica: 'costarica',
  camarones: 'cameroon',
  cameroon: 'cameroon',
  gana: 'ghana',
  ghana: 'ghana',
  senegal: 'senegal',
  polonia: 'poland',
  poland: 'poland',
  dinamarca: 'denmark',
  denmark: 'denmark',
  croacia: 'croatia',
  croatia: 'croatia',
  servia: 'serbia',
  serbia: 'serbia',
};

export function basicNameKey(value: string | undefined): string {
  return String(value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '');
}

export function teamNameKey(value: string | undefined): string {
  const key = basicNameKey(value);
  return TEAM_ALIASES[key] ?? key;
}

export function sameTeamName(left: string | undefined, right: string | undefined): boolean {
  const a = teamNameKey(left);
  const b = teamNameKey(right);
  if (!a || !b) return false;
  if (a === b) return true;
  return a.length >= 5 && b.length >= 5 && (a.includes(b) || b.includes(a));
}

export function sameFootballMatch(left: FootballGame, right: FootballGame): boolean {
  const sameDirection =
    sameTeamName(left.homeTeam.name || left.homeTeam.shortName, right.homeTeam.name || right.homeTeam.shortName) &&
    sameTeamName(left.awayTeam.name || left.awayTeam.shortName, right.awayTeam.name || right.awayTeam.shortName);

  const swappedDirection =
    sameTeamName(left.homeTeam.name || left.homeTeam.shortName, right.awayTeam.name || right.awayTeam.shortName) &&
    sameTeamName(left.awayTeam.name || left.awayTeam.shortName, right.homeTeam.name || right.homeTeam.shortName);

  return sameDirection || swappedDirection;
}
